import { TypographySM } from "@/components/typography/SM";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { WhiteLabelLandingPageEnabled } from "@/lib/white-label-branding/getWhiteLabelBrand";
import { useState } from "react";
import { useHandleRequestAccess } from "../hooks/handleRequestAccess";

interface Props {
  brand: WhiteLabelLandingPageEnabled;
}

function RequestAccessForm({ brand }: Props) {
  const [disableSubmit, setDisableSubmit] = useState(true);
  const { handleRequestAccess, loading } = useHandleRequestAccess(brand);

  return (
    <div>
      <TypographySM className="font-bold mb-2">Request access</TypographySM>
      <TypographySM className="mb-6">
        Not yet a member? Input your email and a message and an admin will
        process your request.
      </TypographySM>

      <form
        onSubmit={handleRequestAccess}
        onChange={(e) => setDisableSubmit(!e.currentTarget.checkValidity())}
      >
        <Label htmlFor="email">Email *</Label>
        <Input
          name="email"
          type="email"
          className="mb-2 text-black dark:text-black"
          required
          placeholder="your@email.com"
        />
        <Label htmlFor="message">Message</Label>
        <Textarea
          name="message"
          className="h-44"
          placeholder="Type your message..."
        />
        <Button
          variant="secondary"
          type="submit"
          disabled={disableSubmit || loading}
          className="bg-brand-primary hover:opacity-80 mt-6 w-full text-white transition-opacity"
          style={
            brand.brandColorHex
              ? {
                  backgroundColor: brand.brandColorHex
                }
              : undefined
          }
        >
          Request access
        </Button>
      </form>
    </div>
  );
}

export default RequestAccessForm;
